import { spUsersApi } from './spusers';

export const verifyOtpApi = spUsersApi.injectEndpoints({
  endpoints: (builder) => ({

    verifyOtp: builder.mutation({
      query: ({ payload }) => ({
        url:    '/phone/verify-otp',
        method: 'POST',
        body:   payload,
      }),
      invalidatesTags: ['phoneVerification'],
    }),

  }),
  overrideExisting: false,
});

export const { useVerifyOtpMutation } = verifyOtpApi;